var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLiked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons=Liked"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 20.725L10.65 19.5125C8.99557 18.0196 7.62779 16.7318 6.54668 15.6491C5.46556 14.5664 4.60597 13.5967 3.9679 12.74C3.32982 11.8833 2.88398 11.0959 2.6304 10.3779C2.3768 9.65995 2.25 8.92564 2.25 8.17501C2.25 6.65819 2.75829 5.39148 3.77487 4.37488C4.79147 3.3583 6.05818 2.85001 7.575 2.85001C8.4298 2.85001 9.2435 3.03334 10.0161 3.40001C10.7887 3.76667 11.45 4.29167 12 4.97501C12.575 4.29167 13.2417 3.76667 14 3.40001C14.7583 3.03334 15.5667 2.85001 16.425 2.85001C17.9418 2.85001 19.2085 3.3583 20.2251 4.37488C21.2417 5.39148 21.75 6.65819 21.75 8.17501C21.75 8.92564 21.6232 9.65995 21.3696 10.3779C21.116 11.0959 20.6702 11.8833 20.0321 12.74C19.394 13.5967 18.5344 14.5664 17.4533 15.6491C16.3722 16.7318 15.0044 18.0196 13.35 19.5125L12 20.725Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLiked);
export default __webpack_public_path__ + "static/media/icon-liked.b32ffe4a3e12f9fadcd362d4e8dc23e4.svg";
export { ForwardRef as ReactComponent };